import React from 'react';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { ContentPropsT } from './constants';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './formConfig';
import useContent from './useContent';

const CreateTicket = (props: ContentPropsT) => {
	const { handleForceUpdate, onClose, createTicket } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useContent({
		handleForceUpdate,
		onClose,
		createTicket
	});

	return (
		<div className={css({ width: '100%' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default CreateTicket;
